import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import Auth from '@/components/pages/Auth'
import Manager from '@/components/pages/Manager'
import Loading from '@/components/pages/Loading'
import FilterPage from '@/components/pages/FilterPage'
import ItemDetail from '@/components/pages/ItemDetail'
import Settings from '@/components/pages/Settings'
import Tools from '@/components/pages/Tools'
import Help from '@/components/Help'
import FirebaseAuth from '@/components/FirebaseAuth'

import store from '@/store'

Vue.use(Router)

const forLogged = (whereTo) => {
  return (to, from, next) => {
    if (!store.getters['auth/isLogged']) {
      return next(whereTo)
    }
    next()
  }
}

const forNotLogged = (whereTo) => {
  return (to, from, next) => {
    if (store.getters['auth/isLogged']) {
      return next(whereTo)
    }
    next()
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: forNotLogged({name: 'loader'})
    },
    {
      path: '/help/',
      name: 'help',
      component: Help
    },
    {
      path: '/auth/',
      name: 'auth',
      component: Auth
    },
    {
      path: '/firebase-auth/',
      name: 'firebase-auth',
      component: FirebaseAuth
    },
    {
      path: '/manager/',
      name: 'loader',
      component: Loading,
      beforeEnter: forLogged('/')
    },
    {
      path: '/manager/:character/',
      name: 'manager',
      component: Manager,
      beforeEnter: forLogged('/')
    },
    {
      path: '/item/:instanceId/',
      name: 'item',
      component: ItemDetail,
      beforeEnter: forLogged('/'),
      props: true
    },
    {
      path: '/filter/',
      name: 'filter',
      component: FilterPage,
      beforeEnter: forLogged('/')
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/tools',
      name: 'tools',
      component: Tools,
      beforeEnter: forLogged('/')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js